import { Dauer } from '../../dtos';
import { GERMAN_LOCALE } from './german';

const durationFormatter = new Intl.DurationFormat(GERMAN_LOCALE, { style: 'long' });

export const formatDuration = (duration: Dauer): string => durationFormatter.format(duration);
